import {
  Button,
  Loader,
  Heading,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Flex,
  Card,
  Alert,
  Text,
  TextField,
  useAuthenticator,
} from "@aws-amplify/ui-react";
import { Modal, Placeholder } from "rsuite";

import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { DeleteProfileMutation } from "./api/useProfileMutation";
import { useUserMutation } from "../common/useUserMutation";

export default function Settings() {
  const { signOut } = useAuthenticator((context) => [context.user]);
  const { mutate: userMutate } = useUserMutation();
  const [open, setOpen] = useState(false);
  const [deleteKeyword, setDeleteKeyword] = useState("");
  const [error, setError] = useState(null);
  const [mutateIsSuccess, setMutateIsSuccess] = useState(false);
  const {
    mutate: deleteProfileMutation,
    isLoading: deleteProfileIsLoading,
    error: deleteProfileError,
    isSuccess: deleteProfileIsSuccess,
  } = DeleteProfileMutation();

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  useEffect(() => {
    if (deleteProfileIsSuccess) {
      sessionStorage.clear();
      userMutate({ patientUserId: undefined, isAdvocating: false });
      signOut();
      window.location.href = "/";
    }
  }, [deleteProfileIsSuccess]);

  useEffect(() => {
    if (deleteProfileError) {
      console.log("deleteProfileError: ", deleteProfileError);
    }
  }, [deleteProfileError]);

  const handleOk = () => {
    const deleteKeyworkValue = deleteKeyword.trim().toLowerCase();
    if (deleteKeyworkValue === "delete") {
      handleClose();
      setError(null);
      setDeleteKeyword("");
      deleteProfileMutation();
      console.log("ready to delete profile");
    } else {
      const validationError = "Please type in 'DELETE'";
      setError(validationError);
      console.log(validationError);
    }
  };

  if (deleteProfileError)
    return (
      <Flex margin={15} alignItems={"center"}>
        <Alert variation="error" hasIcon={true}>
          An error ocurred while deactivating your profile. Please refresh this
          page and try again.
        </Alert>
      </Flex>
    );

  if (deleteProfileIsLoading)
    return (
      <Flex margin={15} alignItems={"center"}>
        <Loader />
        Deleting your profile, please wait...
      </Flex>
    );

  return (
    <>
      <Modal open={open} onClose={handleClose}>
        <Modal.Header>
          <Modal.Title>Deactivate your Total Care Compass account?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Text>
            If you want to proceed with your profile deactivation, please enter
            'DELETE' in the text field below
          </Text>
          <TextField
            size="small"
            placeholder="type in the DELETE keyword"
            value={deleteKeyword}
            onChange={(e) => setDeleteKeyword(e.target.value)}
            errorMessage={error}
            hasError={!!error}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button size="small" onClick={handleOk}>
            Ok
          </Button>
          <Button size="small" onClick={handleClose}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
      <Card marginTop={12}>
        <Flex direction={"row"} gap={12}>
          <Heading level={1} children={`Settings`} />
        </Flex>
        <Flex direction={"column"} gap={12} marginTop={12}>
          <Heading level={5} children={`Account Deactivation`} />

          <Table>
            <TableHead>
              <TableRow>
                <TableCell as="th">Action</TableCell>
                <TableCell as="th">Effect</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>
                  <Button
                    variation="destructive"
                    size="small"
                    onClick={handleOpen}
                  >
                    Deactivate
                  </Button>
                </TableCell>
                <TableCell>
                  <Alert
                    heading={
                      "Deactivating your account is an unrecoverable action and once performed you will no longer be able to bring your profile back again."
                    }
                    shrink={1}
                    hasIcon={true}
                    variation="warning"
                  >
                    Deactivating your account means that you no longer will have
                    a Total Care Compass profile. Also your health records will be
                    deactivated, making them unavailable to anyone you shared
                    them with.
                  </Alert>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Flex>
      </Card>
    </>
  );
}
